// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1yOZp","text":"SelectPayment_text__2Ug7M","title":"SelectPayment_title__77CQN","btn":"SelectPayment_btn__1BvXj"};